import * as React from 'react';

const AdobeAnalyticsScript: React.FC<{path: string}> = (props: {path: string}) => {

  /*
   * Adobe Analyticsでタクシー予約画面のアクセス数の集計をする。
   * AM-232: debugモードではAdobeAnalyticsタグを読み込まないようにします
   * https://ana-maas-val.atlassian.net/browse/AM-232
   */
  React.useEffect(() => {
    if (typeof window !== "undefined" && typeof (window as any).s !== "undefined") {
      (window as any).s.pageName = window.location.origin + props.path;
      (window as any).s.t();
    }
  }, [window, (window as any).s]);
  return null;
}

export default AdobeAnalyticsScript;